import { IconButton, Typography, Box, Avatar, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import { font } from "../../styles/font";
import { theme } from "../../styles/theme";
import { ApplicationContext } from "../../context/application_ctx";
import { useNavigate } from "react-router-dom";
import { stringToArray, stringToColor } from "../../utility/string";
// import { stringAvatar } from "../../utility/string";

export const NavigationDock = ({
  navItems,
  dashboardQuery,
  setDockMenu,
  admin,
  dialog
}) => {
  const navigate = useNavigate();
  // context
  const {
    activeTab,
    setActiveTab,
    setTableView,
    setHeader,
    profileDetails,
    assignDetails,
    dockMenu
  } = useContext(ApplicationContext);

  // profileDetails.isPaymentDone = false
  // profileDetails.hasAvailedDemo = true

  const handleTab = (i) => {
    setActiveTab(i);
    if(dialog && dockMenu){
      setDockMenu(false)
    }
    setHeader(null)
    if (!admin) {
      setDockMenu(false);
      switch (i) {
        case 0:
          navigate("/dashboard");
          setTableView(0);
          break;
        case 1:
          navigate("/employee-onboarding");
          setHeader("");
          break;
        case 2:
          navigate("/licence");
          break;
        case 3:
          navigate("/user-profile");
          break;
        case 4:
          navigate("/company-profile");
          break;
        default:
          return;
      }
    }

    // if(profileDetails?.hasAvailedDemo && !profileDetails.isPaymentDone){
    //   setExpiryDialog(true);

    // }
    // if(profileDetails?.isPaymentDone && !dayjs().isBefore(profileDetails.licenseExpirationDate)){
    //   setExpiryDialog(true);

    // }
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      width={dashboardQuery ? "100%" : "12%"}
      // boxShadow="0px 0px 12px -1px grey"
      borderRight="1px solid #d7d7d7"
      backgroundColor={theme.col_4}
      height="100%"
    >
      <Box
        width="100%"
        height="113px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          display={"flex"}
          width="97px"
          justifyContent="center"
          height="64px"
        >
        {dialog ? <>
        
          <Box
            alignItems="center"
            onClick={()=>setActiveTab(3)}
            pl={2}
            pr={1.5}
            py={1}
            gap="8px"
            sx={{
              cursor: "pointer",
              "&:hover": { background: theme.col_2_alpha2, },
            }}
            display="flex"
            border={`1px solid ${theme.col_5}`}
            backgroundColor={theme.col_4}
            borderRadius="6px"
          >
            <Typography
              color={theme.col_6}
              fontWeight="bold"
              fontFamily={font.family.fm_2}
              fontSize={font.size.fs_5}
            >
              {admin ? profileDetails?.name : profileDetails?.companyName}
            </Typography>

            <Box
              display="flex"
              alignItems="center"
              width="30px"
              height="30px"
              borderRadius="50px"
              flexDirection="column"
              justifyContent="center"
              backgroundColor={stringToColor(
                admin
                  ? profileDetails?.name?.split(" ")[0] ?? "green"
                  : profileDetails?.companyName?.split(" ")[0] ?? "green"
              )}
            >
              <Typography
                fontFamily={font.family.fm_2}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                color={theme.col_4}
                textTransform="capitalize"
              >
                {stringToArray(
                  admin
                    ? profileDetails?.name?.split(" ")[0] ?? ''
                    : profileDetails?.companyName?.split(" ")[0] ?? ""
                )}
              </Typography>
            </Box>
          </Box>
        </> :  <img
            width={"100%"}
            height="100%"
            src={require("../../assets/images/logo.png")}
            alt="Mindamigo"
          />}
        </Box>
      </Box>
      <Box
        width="100%"
        display="flex"
        gap="17px"
        flexDirection="column"
        flex="1"
        alignItems="flex-start"
      >
        {navItems.map((items, i) => {
          return (
            <>
              <Box
                borderRadius={"0px 20px 20px 0px"}
                width={"88%"}
                // disabled={profileDetails.hasAvailedDemo ? true : false}
                onClick={() => handleTab(i)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.col_2_alpha,
                  },
                }}
                backgroundColor={
                  activeTab === i ? theme.col_2_alpha : "transparent"
                }
                // backgroundRipple={theme.col_2_alpha}
                // focusColor={theme.col_2}
                display={i === 2 && dialog ? 'none' : "flex"}
                alignItems="center"
                // justifyContent="center"
                px={3}
                py={1}

                // startIcon={items.icon}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  textAlign="left"
                  fontWeight="bold"
                  color={activeTab === i ? theme.col_2 : theme.col_6}
                >
                  {items?.label}
                </Typography>
              </Box>
            </>
          );
        })}
      </Box>
      {admin && !dialog ? (
        <></>
      ) : (
        <Box
          onClick={() => {
            if(!dialog){

              setDockMenu(false);
              navigate("/representative-profile");
            }
            setActiveTab(5);
          }}
          sx={{ cursor: "pointer" }}
          width="90%"
          display="flex"
          gap="7px"
          flexDirection="column"
          flex="1"
          alignItems="center"
          justifyContent="flex-end"
          pb={3}
        >
          <Tooltip
            placement="right"
            arrow
            title={
              <Box
                // width="250px"
                display="flex"
                flexDirection="column"
                gap="6px"
                p={1}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  textAlign="left"
                  color={theme.col_1}
                  sx={{ wordBreak: "break-all" }}
                >
                  Representative:{" "}
                  {!assignDetails?.assignedAdminName
                    ? "Adam"
                    : assignDetails?.assignedAdminName}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  fontSize={font.size.fs_3}
                  textAlign="left"
                  color={theme.col_1}
                  sx={{ wordBreak: "break-all" }}
                >
                  Email:{" "}
                  {!assignDetails?.assignedAdminEmail
                    ? "adam.chadwick@mindamigo.com"
                    : assignDetails?.assignedAdminEmail}
                </Typography>
                {/* {assignDetails?.assignedAdminName ? (
                  <Typography
                    fontFamily={font.family.fm_2}
                    fontSize={font.size.fs_3}
                    textAlign="left"
                    color={theme.col_1}
                    sx={{ wordBreak: "break-all" }}
                  >
                    Respond By: {assignDetails?.assignedAdminName}
                  </Typography>
                ) : (
                  <></>
                )} */}
              </Box>
            }
          >
            <Avatar />
          </Tooltip>
          <Typography
            fontFamily={font.family.fm_2}
            textTransform={"capitalize"}
            fontSize={font.size.fs_4}
            textAlign="center"
            fontWeight="bold"
            color={theme.col_6}
            sx={{ wordBreak: "break-all" }}
          >
            MA Representative
          </Typography>

          {/* <Typography
          fontFamily={font.family.fm_2}
          textTransform={"capitalize"}
          fontSize={font.size.fs_4}
          textAlign="left"
          fontWeight="bold"
          color={theme.col_6}
          sx={{ wordBreak: "break-all" }}
        >
          Representative:  {!assignDetails?.assignedAdminName ? "Adam" :  assignDetails?.assignedAdminName}
        </Typography>
        <Typography
          fontFamily={font.family.fm_2}
          fontSize={font.size.fs_4}
          textAlign="left"
          fontWeight="bold"
          color={theme.col_6}
          sx={{ wordBreak: "break-all" }}
        >
          Email: {!assignDetails?.assignedAdminEmail ? "adam.chadwick@mindamigo.com" :  assignDetails?.assignedAdminEmail}
        </Typography> */}
          {/* {assignDetails?.assignedAdminName  ? <Typography
          fontFamily={font.family.fm_2}
          fontSize={font.size.fs_4}
          textAlign="left"
          fontWeight="bold"
          color={theme.col_6}
          sx={{ wordBreak: "break-all" }}
        >
          Respond By: {assignDetails?.assignedAdminName}
        </Typography> : <></>} */}
        </Box>
      )}
    </Box>
  );
};

export const BottomNavBar = ({ navItems }) => {
  // context
  const navigate = useNavigate();
  const { setActiveTab, setHeader, setTableView } =
    useContext(ApplicationContext);
  const handleTab = (i) => {
    setActiveTab(i);
    switch (i) {
      case 0:
        navigate("/dashboard");
        setTableView(0);
        break;
      case 1:
        navigate("/employee-onboarding");
        setHeader("");
        break;
      case 2:
        navigate("/licence");
        break;
      case 3:
        navigate("/user-profile");
        break;
      case 4:
        navigate("/company-profile");
        break;
      default:
        return;
    }
  };
  return (
    <>
      <Box
        width="100%"
        height={"50px"}
        borderRadius={"42px"}
        backgroundColor={theme.col_2_alpha}
        marginTop="12px"
        position="absolute"
        bottom="0px"
        // height="58px"
        display="flex"
        flexDirection={"row"}
        alignItems="center"
        justifyContent="center"
        sx={{ backdropFilter: "blur(45px)" }}
        gap="8px"
        py={1}
        zIndex={2}
      >
        {navItems.map((items, i) => {
          return (
            <>
              <IconButton
                onClick={() => handleTab(i)}
                sx={{ fontSize: "32px" }}
              >
                {items.icon}
              </IconButton>
            </>
            // <ButtonCustom
            //   borderRadius={"20px 20px 20px 20px"}
            //   // width={"96%"}
            //   typography={
            //     <Typography
            //       fontFamily={font.family.fm_2}
            //       textTransform={"capitalize"}
            //       fontSize={font.size.fs_3}
            //       fontWeight="bold"
            //       color={theme.col_6}
            //     >
            //       {items.icon}
            //     </Typography>
            //   }
            // //  startIcon={items.icon}
            //   // onClick={() => setActiveTab(i)}
            //   // background={activeTab === i ? theme.col_2 : "white"}
            //   backgroundRipple={theme.col_2}
            // />
          );
        })}
      </Box>
    </>
  );
};
